import { render, staticRenderFns } from "./HeaderSystem.vue?vue&type=template&id=50f7d4f4&scoped=true&"
import script from "./HeaderSystem.vue?vue&type=script&lang=js&"
export * from "./HeaderSystem.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSystem.vue?vue&type=style&index=0&id=50f7d4f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f7d4f4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseUiModalAction: require('/var/www/html/intelli.com.br/components/base/ui/ModalAction.vue').default})
